import React from 'react'
import { Box, Container } from '@mui/material'
import PropTypes from 'prop-types'
import { BANNER_VARIANTS } from '../Sections.const'
import { useBanner } from './Banner.hooks'

const Banner = props => {
	const [{ classes, cx, metaData, variant, Element }] = useBanner(props)

	return (
		<Box className={cx(variant, classes.root, classes[variant], 'section-banner')}>
			<Container className={cx(classes.content, 'section-banner-content')}>
				{Element && <Element metaData={metaData} />}
			</Container>
		</Box>
	)
}

Banner.propTypes = {
	variant: PropTypes.oneOf(Object.values(BANNER_VARIANTS)),
	Element: PropTypes.elementType,
}

export default Banner
